export default __webpack_public_path__ + "static/media/photo--lg--pam2.bbb38606.jpg";